import React from "react"
import Backdrop from "../../layouts/Backdrop/Backdrop"
import popup from "./Popup.module.css"
import { IoClose } from "react-icons/io5"


interface PopupProps {
    popupTitle: string
    showPopup: boolean
    setShowPopup: (val: boolean) => void
    popupContent: React.JSX.Element
}

export default function Popup(props: PopupProps) {
    const { popupTitle, showPopup, setShowPopup, popupContent } = props

    return (
        <>
            {showPopup && <Backdrop close={() => setShowPopup(false)} />}
            <div className={popup.modalmobile} id={showPopup ? undefined : popup.hide} style={{ maxWidth: '1200px' }}>
                <div className={popup.headerTitle}>
                    <h2>{popupTitle.replace("_", " ") ?? ''}</h2>

                    <button onClick={() => setShowPopup(false)}>
                        <IoClose strokeWidth={20} />
                    </button>
                </div>

                <div>
                    {popupContent}
                </div>
            </div>
        </>
    );
}
